/**
 * Escape HTML — SSOT del admin para sanitizar contenido de usuario/DB
 * antes de interpolarlo en strings de innerHTML o template literals.
 *
 * POR QUE EXISTE: gran parte del admin construye HTML concatenando
 * strings (patrón heredado pre-framework). Cualquier campo editable
 * por un humano (nombre de serie, notas, descripcion de nodo, etc.)
 * que llegue de la API y se concatene sin escapar es un vector XSS.
 * Un superadmin malicioso podria guardar `<img src=x onerror=...>` en
 * el nombre de una serie y ejecutar codigo en otros admins.
 *
 * USO:
 *   import { escapeHtmlParaInyeccionSegura } from '../utils/escape-html-para-inyeccion-segura.js';
 *   html += '<td>' + escapeHtmlParaInyeccionSegura(serie.nombre) + '</td>';
 *
 * Para interpolacion en atributos (value=".." o title=".."), el escape
 * es el mismo: las 5 entidades (& < > " ') cubren tanto body como
 * atributos rodeados por comillas dobles o simples.
 *
 * No usar para URLs (usa encodeURI/encodeURIComponent), ni para JSON
 * dentro de <script> (usa JSON.stringify + escapar </script>).
 */

// La implementación vive en el SSOT (`shared/utils/escape-html.js`), que
// nació de ESTE archivo: era la copia más completa de las tres que había.
// Acá queda el alias con el nombre que ya usan decenas de módulos del admin,
// para no tocarlos en un fix de seguridad.
import { escapeHtml } from '@shared/utils/escape-html.js';

export function escapeHtmlParaInyeccionSegura(textoCrudoDeUsuarioODb) {
    return escapeHtml(textoCrudoDeUsuarioODb);
}
